import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react';
import ReturnToMerchantLink from '../../components/returnToMerchant';
import { isExternalFlow } from '../../utility/productIntegrationUtils';
import CloseButton from '../../components/CloseButton';
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react';
import { MessageFormat } from '@paypalcorp/worldready';

const ReceiverEligibilityErrorTile = ({ organizationName, returnUrl }) => {
  const worldReady = useContext(WorldReadyContext);

  return (
    <>
      {isExternalFlow() && <CloseButton />}
      <div
        className="receiver-eligibility-error-tile"
        data-testid="receiver-eligibility-error-tile"
      >
        <HeadingText size="lg">
          <Message id="errors.landingerror.error.receiveDonationNotAllowed" />
        </HeadingText>
        {returnUrl && (
          <ReturnToMerchantLink
            returnLabel={new MessageFormat(worldReady, {
              id: 'errors.landingerror.label.returnTo',
            }).format({ orgName: organizationName })}
            organizationName={organizationName}
            returnUrl={returnUrl}
          />
        )}
      </div>
    </>
  );
};

ReceiverEligibilityErrorTile.propTypes = {
  organizationName: PropTypes.string,
  returnUrl: PropTypes.string,
};

export default ReceiverEligibilityErrorTile;
